import React from "react";

export default function PricingDetail(props) {
  const { children } = props;

  return <div className="pricing-section">{children}</div>;
}
